import { createSwiper } from './swiper';

const pauseOtherVideos = (currentVideo) => {
  document.querySelectorAll('.ugc-slider__video').forEach((video) => {
    if (video === currentVideo) return;

    video.pause();
    video.closest('.ugc-slider__slide, .swiper__col')?.classList.add('is-paused');
  });
};

const playActiveVideo = (carousel) => {
  carousel.querySelectorAll('.swiper__col').forEach((slide) => {
    const video = slide.querySelector('.ugc-slider__video');
    if (!video) return;

    if (slide.classList.contains('swiper-slide-active')) {
      pauseOtherVideos(video);
      video.play();
      slide.classList.remove('is-paused');
    } else {
      video.pause();
      slide.classList.add('is-paused');
    }
  });
};

const initVideoControls = (section) => {
  section.querySelectorAll('.ugc-slider__slide').forEach((slide) => {
    const video = slide.querySelector('.ugc-slider__video');
    if (!video) return;

    const playBtn = slide.querySelector('.ugc-slider__play-btn');
    const pauseBtn = slide.querySelector('.ugc-slider__control--pause');
    const muteBtn = slide.querySelector('.ugc-slider__control--mute');

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        pauseOtherVideos(video);
        video.play();
        slide.classList.remove('is-paused');
      });
    }

    if (pauseBtn) {
      pauseBtn.addEventListener('click', () => {
        video.pause();
        slide.classList.add('is-paused');
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        slide.classList.toggle('is-unmuted', !video.muted);
      });
    }
  });
};

const initUgcSlider = (section) => {
  const carousel = section.querySelector('.ugc-slider__carousel');
  if (!carousel || carousel.swiper) return;

  const instance = createSwiper(carousel, {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 8,
    loop: true,
    slideClass: 'swiper__col',
    wrapperClass: 'swiper__row',
    navigation: {
      nextEl: carousel.querySelector('.ugc-slider__nav-btn--next'),
      prevEl: carousel.querySelector('.ugc-slider__nav-btn--prev'),
    },
    breakpoints: {
      768: {
        centeredSlides: false,
        loop: false,
        spaceBetween: 16,
      },
    },
    a11y: { enabled: true },
  });

  instance.on('slideChangeTransitionEnd', () => playActiveVideo(carousel));

  initVideoControls(section);
  playActiveVideo(carousel);

  return instance;
};

const observeSection = (section) => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          initUgcSlider(section);
          observer.disconnect();
        }
      });
    },
    { rootMargin: '200px' }
  );
  observer.observe(section);
};

const ugcSlider = () => {
  document.querySelectorAll('.ugc-slider').forEach(observeSection);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.ugc-slider');
    if (section) initUgcSlider(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const carousel = e.target.querySelector('.ugc-slider__carousel');
    if (carousel?.swiper) carousel.swiper.destroy(true, true);
  });

  document.addEventListener('shopify:block:select', (e) => {
    const carousel = e.target.closest('.ugc-slider__carousel');
    if (!carousel?.swiper) return;
    const slide = e.target.closest('.swiper__col');
    if (!slide) return;
    const index = Array.from(carousel.querySelectorAll('.swiper__col')).indexOf(slide);
    if (index >= 0) carousel.swiper.slideToLoop(index);
  });
};

export default ugcSlider;
